<template>
  <a-modal
    v-model="showModal"
    :title="title"
    width="78%"
    :footer="null"
    :maskClosable="false"
    :dialogStyle="{ top: '6%' }"
    @cancel="handleCancel"
  >
    <div
      style="
        padding: 20px 26px 35px;
        height: 430px;
        overflow-y: auto;
      "
    >
      <div style="margin-top: 15px" v-if="orders.length > 0">
        <div class="title">套餐订单</div>
        <table style="width: 100%" v-for="(order,i) in orders" :key="i">
          <tr style="line-height: 25px">
            <td class="tds table_td_label">订单编号：</td>
            <td class="tdvs1">{{order.order_num}}</td>
            <td class="tds table_td_label">预约国家：</td>
            <td class="tdvs1">{{order.countrycode}}</td>
            <td class="tds table_td_label">套餐流量：</td>
            <td class="tdvs1">{{order.Packet_flow}} KB</td>
            <td class="tds table_td_label">下单时间：</td>
            <td class="tdvs1">{{order.ordertime}}</td>
           
          </tr>
          <tr style="line-height: 25px">
            <td class="tds table_td_label">套餐时长：</td>
            <td class="tdvs1">{{order.allTime}}</td>
            <td class="tds table_td_label">金额：</td>
            <td class="tdvs1" v-if="order.price != -1">{{order.price}}</td>
            <td class="tdvs1" v-else>-</td>
            <td class="tds table_td_label">状态：</td>
            <td class="tdvs1">{{order.status}}</td>
            <td class="tds table_td_label">生效时间：</td>
            <td class="tdvs1">{{order.valid_startdate}} / {{order.valid_enddate}}</td>
          </tr>
          <tr> 
            <td colspan="4" style="text-align:left;padding-left:3px;"><span class="table_td_label">已用流量/最大流量：</span>{{order.usedflow}}/{{order.maxFlow}}</td>
          </tr>
        </table>
      </div>
      <div style="margin-top: 15px" v-if="autoSub.length > 0">
        <div class="title">自动续订</div>
        <table style="width: 100%;margin-bottom:15px;" v-for="(sub, i) in autoSub" :key="i">
          <tr style="line-height: 25px">
            <td class="tds table_td_label table_td_label1">套餐名称：</td>
            <td class="tdvs tdvs_value">{{sub.attachName}}</td>
            <td class="tds table_td_label table_td_label1">套餐价格：</td>
            <td class="tdvs tdvs_value" v-if="sub.packetprice != -1">{{sub.packetprice}}</td>
            <td class="tdvs tdvs_value" v-else>-</td>
            <td class="tds table_td_label table_td_label2">套餐国家：</td>
            <td class="tdvs tdvs_value">{{sub.countryName}}</td>
          </tr>
          <tr style="line-height: 25px">
            <td class="tds table_td_label table_td_label1">操作账号：</td>
            <td class="tdvs tdvs_value" :title="sub.operatorid">{{sub.operatorid}}</td>
            <td class="tds table_td_label table_td_label1">订单状态：</td>
            <td class="tdvs tdvs_value">{{sub.status==0?'正常':sub.status==2?'停用':''}}</td>
            <td class="tds table_td_label table_td_label2">操作时间：</td>
            <td class="tdvs tdvs_value">{{sub.updatetime}}</td>
          </tr>
          <tr style="line-height: 25px">
            <td class="tds table_td_label table_td_label1">开始时间：</td>
            <td class="tdvs tdvs_value">{{sub.begintime}}</td>
            <td class="tds table_td_label table_td_label1">截止时间：</td>
            <td class="tdvs tdvs_value">{{sub.endtime}}</td>
            <td class="tds table_td_label table_td_label2">流量用完是否续订：</td>
            <td class="tdvs tdvs_value">{{sub.usedUp==1?"否":sub.usedUp==0?"是":''}}</td>
          </tr>
        </table>
      </div>
      <div v-if="orders.length == 0 && autoSub.length == 0">没有数据</div>
    </div>
  </a-modal>
</template>
<script>
import { errMsg, isNull, warnMsg } from "../../../utils/CommonUtils.js";
export default {
  props: ["tsid"],
  data() {
    return {
      title: "详情",
      showModal: false,
      orders: [],
      autoSub: [],
    };
  },
  created() {
    this.showModal = true;
    this.init();
  },
  methods: {
    init() {
      if (isNull(this.tsid)) {
        return;
      }
      this.axios.post(this.baseUrl + "getDetailOrder?tsid=" + this.tsid, "", {
          headers: { token: sessionStorage.getItem("token") },
        }).then((res) => {
          if (res.status == 200) {
            if (res.data.code == 0) {
              let data = res.data.data;
              for (let i = 0; i < data.length; i++) {
                let order = data[i];
                order.status = order.status == 0 ? "正常" : order.status == 2 ? "停用" : "";
                order.allTime = order.time_unit == 1 ? order.days + "月" : order.time_unit == 0
                    ? order.days == 365 ? "1年" : order.days == 730 ? "2年" : order.days + "天" : "";
              }
              this.orders = data;
            }else if (res.data.code == -1) {
              warnMsg("请先登录");
              setTimeout(() => {
                this.$router.push({ name: "login" });
              }, "2000");
            }
          }
        }).catch(() => {
          errMsg("系统异常,请联系客服");
        });

      this.axios.post(this.baseUrl + "getDetailAuto?tsid=" + this.tsid, "", {
          headers: { token: sessionStorage.getItem("token") },
        }).then((res) => {
          if (res.status == 200) {
            if (res.data.code == 0) {
              this.autoSub = res.data.data;
            }
          }
        })
    },
    handleCancel() {
      this.$emit("inactive-detail-visible", false);
    },
  },
};
</script>
<style scoped>

.table_1 {
  width: 100%;
  font-size: 12px;
}
.table_1_tr {
  height: 45px;
  line-height: 25px;
}
.table_1_td_label {
  min-width: 45px;
  text-align: right;
}

.table_td_label {
  width: 80px;
  font-weight: bold;
}
.table_td_label1{
  width: 100px;
}
.table_td_label2{
  width: 150px;
}
.table_1_td_label2 {
  min-width: 65px;
  text-align: right;
}

.table_1_input_text {
  border: 0px;
  outline-width: 0px;
  background-color: #fafafa;
}
.title {
  padding: 5px;
  font-weight: 800;
  font-size: 18px;
}
.tds {
  text-align: right;
}
.tdvs1{
 text-align: left;
 width: 190px;
}
.tdvs {
  text-align: left;
}
.tdvs_value{
  display: inline-block;
  width: 150px;
  word-break:keep-all;/* 不换行 */
  white-space:nowrap;/* 不换行 */
  overflow:hidden;
  text-overflow:ellipsis;
}
.ivs {
  cursor: no-drop;
  border: 1px solid #c2c2c2;
  border-color: #cccccc;
  -webkit-box-shadow: 0 0 3px #c2c2c2;
  -moz-box-shadow: 0 0 3px #c2c2c2;
  box-shadow: 0 0 3px #c2c2c2;
}

/* 限制备注内容过多 */
.note_wrap {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-indent: 28px;
}

::v-deep .ant-modal-body {
  padding: 0px;
}
</style>